import { z } from 'zod';

export const storageWindowSchema = z.enum(['7d', '30d', '90d']);
export type StorageWindow = z.infer<typeof storageWindowSchema>;

export const storageAppSchema = z.object({
  appId: z.string(),
  appName: z.string(),
  status: z.enum(['ACTIVE', 'ORPHAN']),
  quotaBytes: z.number().nullable(),
  bytesUsed: z.string(),
  quotaUsedPercent: z.number().nullable(),
  fileCount: z.number(),
  pendingCount: z.number(),
  stalePendingCount: z.number(),
  bytesAdded7d: z.string(),
  bytesAdded30d: z.string(),
});
export type StorageApp = z.infer<typeof storageAppSchema>;

export const storageOverviewSchema = z.object({
  totalBytesUsed: z.string(),
  totalQuotaBytes: z.string(),
  totalFiles: z.number(),
  totalPending: z.number(),
  totalStalePending: z.number(),
  bytesAdded7d: z.string(),
  bytesAdded30d: z.string(),
  nearQuota: z.array(storageAppSchema),
  apps: z.array(storageAppSchema),
  generatedAt: z.string(),
});
export type StorageOverview = z.infer<typeof storageOverviewSchema>;

export const storageSeriesSchema = z.object({
  window: storageWindowSchema,
  bucketSeconds: z.number(),
  points: z.array(
    z.object({
      t: z.string(),
      uploadedFiles: z.number(),
      uploadedBytes: z.string(),
      deletedBytes: z.string(),
    }),
  ),
});
export type StorageSeries = z.infer<typeof storageSeriesSchema>;

export const duplicateGroupSchema = z.object({
  sha256: z.string(),
  appId: z.string(),
  appName: z.string(),
  tenantId: z.string().nullable(),
  count: z.number(),
  size: z.string(),
  recoverableBytes: z.string(),
  files: z.array(z.object({ id: z.string(), path: z.string(), createdAt: z.string() })),
});
export type DuplicateGroup = z.infer<typeof duplicateGroupSchema>;

export const duplicateSummarySchema = z.object({
  groups: z.number(),
  files: z.number(),
  recoverableBytes: z.string(),
});
export type DuplicateSummary = z.infer<typeof duplicateSummarySchema>;
